import React from "react";
import "./SectionThree.css";

function SectionThree() {
  return (
    <div className="section-three">
      <div className="container-fluid px-0">
        <div className="row px-0 mx-0">
          <div className="col-12 px-0">
            <div className="section-three-header">
              <img
                src="/img/section-two-footer-line.svg"
                className="img-fluid section-three-header-line"
                alt=""
              />
            </div>
          </div>
          <div className="col-12">
            <div className="section-three-content">
              <div className="container-fluid">
                <div className="row mx-0 px-0">
                  <div className="col-lg-6 px-0 h-100">
                    <div className="section-three-left-column d-flex align-items-center">
                      <div className="container-fluid section-three-left-column-content ">
                        <div className="row px-0 mx-0">
                          <div className="col-12">
                            <span className="section-three-left-column-heading">
                              Real Estate Made{" "}
                              <span className="bold-content">Real Easy.</span>
                            </span>
                          </div>
                        </div>
                        <div className="row px-0 mx-0 mt-4">
                          <div className="col-12">
                            <table>
                              <tbody className="section-three-list-table-body">
                                <tr width="100%">
                                  <td
                                    className="section-three-points"
                                    style={{ width: "160px" }}
                                  >
                                    <img
                                      src="/img/section-three-steps-icon.svg"
                                      alt=""
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span className="mt-2">Step 1</span>
                                  </td>
                                  <td className="section-three-points-text">
                                    Search for homes in the area you wish to
                                    buy. You can search by address, City, State or better yet
                                    an entire zip code to see homes for sale.
                                    When you find a home you like, simply click
                                    on{" "}
                                    <span className="bold-content">
                                      Make and Offer
                                    </span>{" "}
                                    or{" "}
                                    <span className="bold-content">
                                      Take a Tour Button.
                                    </span>
                                  </td>
                                </tr>

                                <tr width="100%">
                                  <td
                                    className="section-three-points"
                                    style={{ width: "160px" }}
                                  >
                                    <img
                                      src="/img/section-three-steps-icon.svg"
                                      alt=""
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span className="mt-2">Step 2</span>
                                  </td>
                                  <td className="section-three-points-text">
                                    Create your profile, and verify your
                                    financing
                                  </td>
                                </tr>
                                <tr width="100%">
                                  <td
                                    className="section-three-points"
                                    style={{ width: "160px" }}
                                  >
                                    <img
                                      src="/img/section-three-steps-icon.svg"
                                      alt=""
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span className="mt-2">Step 3</span>
                                  </td>
                                  <td className="section-three-points-text">
                                    You will then be connected with your
                                    personal{" "}
                                    <span className="bold-content">
                                      Transaction Coordinator
                                    </span>{" "}
                                    who can easily assist you with all stages of
                                    the buying process, including writing an
                                    offer.
                                  </td>
                                </tr>
                                <tr width="100%">
                                  <td
                                    className="section-three-points"
                                    style={{ width: "160px" }}
                                  >
                                    <img
                                      src="/img/section-three-steps-icon.svg"
                                      alt=""
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span className="mt-2">Step 4</span>
                                  </td>
                                  <td className="section-three-points-text">
                                    If not ready to make an offer, you can be
                                    connected to a{" "}
                                    <span className="bold-content">
                                      Showing Agent
                                    </span>{" "}
                                    who can show you as many properties as you
                                    like.
                                  </td>
                                </tr>
                                <tr width="100%">
                                  <td
                                    className="section-three-points"
                                    style={{ width: "160px" }}
                                  >
                                    <img
                                      src="/img/section-three-steps-icon.svg"
                                      alt=""
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span className="mt-2">Step 5</span>
                                  </td>
                                  <td className="section-three-points-text">
                                    A list of Top Rated <span className="bold-content">Service Providers</span> in your
                                    chosen area will be provided to you.
                                    Everything from Home Inspection, Home Owner
                                    Insurance to Gardening is available.
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 px-0 py-0">
                    <div className="section-three-right-column"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionThree;
